export const InviteStatus = Object.freeze({
  pending: 0,
  accepted: 1,
  rejected: 2,
});
